
export class ResearchCenterPage {
    slideIndex: number;
    interval: any;

    constructor() {
        // Document ready
        $(() => {
            this.slideIndex = 0;
            this.showSlides();
            this.createDots();
            this.startAutoSlide();
        });
    }

    changeSlide(n: number) {
        this.slideIndex += n;
        this.showSlides();
    }

    showSlides() {
        let slides: JQuery<HTMLElement> = $(".carousel-slide");
        if (this.slideIndex >= slides.length) { this.slideIndex = 0; }
        if (this.slideIndex < 0) { this.slideIndex = slides.length - 1; }

        slides.addClass("d-none");
        slides[this.slideIndex].classList.remove("d-none");

        this.updateDots();
    }

    createDots() {
        let slides: JQuery<HTMLElement> = $(".carousel-slide");
        let dotsContainer = $(".dots");
        dotsContainer.empty(); // Clear existing dots

        slides.each((index) => {
            dotsContainer.append(`<span class="dot" data-index="${index}"></span>`);
        });

        $(".dot").on("click", (event) => {
            this.slideIndex = $(event.currentTarget).data("index");
            this.showSlides();
        });
    }

    updateDots() {
        $(".dot").removeClass("active");
        $(`.dot[data-index="${this.slideIndex}"]`).addClass("active");
    }

    startAutoSlide() {
        this.interval = setInterval(() => {
            this.slideIndex++;
            this.showSlides();
        }, 10000); // Change slide every 20 seconds
    }
}